import { render, staticRenderFns } from "./setemail.vue?vue&type=template&id=2539b28b&scoped=true&"
import script from "./setemail.vue?vue&type=script&lang=js&"
export * from "./setemail.vue?vue&type=script&lang=js&"
import style0 from "./setemail.vue?vue&type=style&index=0&id=2539b28b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2539b28b",
  null
  
)

export default component.exports